import React from 'react';
import './Investment.css';
import DogManImage from '../assets/images/dogman.jpg';
import Pikachu from '../assets/images/pikachu.jpg';
import Minecraft from '../assets/images/minecraft.png';

const investments = [
  {
    title: 'Dog Man Books',
    description: 'Love reading this series',
    image: DogManImage,
    isFeatured: false
  },
  {
    title: 'Pikachu',
    description: 'My Favorite Pokeman Plush Toy',
    image: Pikachu,
    isFeatured: true // Featured card
  },
  {
    title: 'Minecraft Game',
    description: 'Love playing this game',
    image: Minecraft,
    isFeatured: false
  }
];

const Investment = () => {
  return (
    <div className="investment-container">
      <h2 className="investment-heading">
        My <strong>farorite</strong> <span>things to do</span>
      </h2>
      <div className="investment-cards">
        {investments.map((item, index) => (
          <a
            key={index}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className={`investment-card ${item.isFeatured ? 'featured' : ''}`}
          >
            <img src={item.image} alt={item.title} className="investment-image" />
            <div className="investment-info">
              <h3 className="investment-title">{item.title}</h3>
              <p className="investment-description">{item.description}</p>
              {/*<span className="investment-link">{item.link.replace('https://', '')}</span>*/}
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Investment;